<template>
  <div :class="$style.block">
    <div :class="$style.container">
      <h4 class="line-title" v-if="content.title !== undefined" data-anim="stagger">{{ content.title }}</h4>
      <ul :class="$style.list">
        <li v-for="(icon, index) in content.icons" :key="icon.src">
          <BigIcon :class="$style.icon" :src="icon.src" :index="index"/>
          <p :class="$style.text" v-html="icon.text" data-anim="stagger" :data-stagger="index"></p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import BigIcon from '@/components/BigIcon'

export default {
  props: ['content'],
  components: {
    BigIcon
  }
}
</script>

<style lang="scss" module>
@import "~sass-mq/mq";

.block {
  background: $color-dark-two;
  background-position: center;
  background-size: cover;
  padding: $viewport-margin-mobile 0;
  color: $color-light;

  @include mq(sm) {
    padding: $giga-margin 0;
  }

  h4 {
    max-width: none;
    margin-bottom: $standard-margin-mobile;
    // margin-left: $giga-margin-mobile;
    margin-left: 30px;
    margin-right: 30px;
    width: auto;

    @include mq(sm) {
      margin-right: 0px;
      margin-bottom: $standard-margin;
      margin-left: $giga-margin;
    }
  }
}

.list {
  display: flex;
  flex-wrap: wrap;

  @include mq(sm) {
    flex-wrap: nowrap;
  }

  li {
    width: 100%;
    text-align: center;
    flex: 0 0 auto;
    padding: $standard-margin-mobile;

    @include mq(sm) {
      padding: 0 $standard-margin-mobile;
      width: 33.33%;
    }

    @include mq(ds) {
      padding: 0 $big-margin;
    }
  }
}

.container {
  @include grid-size();
}

.icon {
  margin: 0 auto;
  width: 90px;
  padding: 0;

  @include mq(sm) {
    width: 110px;
    height: 110px;
  }
}

.text {
  font-size: font-size(m);
  margin: $standard-margin-mobile 0;
  margin-bottom: 0;

  @include mq(sm) {
    margin: $standard-margin 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/IconsBlock.vue